import {createFileRoute} from '@tanstack/react-router';
import {CreditsAccountPage} from '../../../../../../features/credit/pages/CreditAccountPage/CreditsAccountPage';

export const Route = createFileRoute(
  '/_protected/home/accounts/credits/$accountId/',
)({
  component: CreditsAccountPage,
});
